import styled from 'styled-components';

import { StyledFlex } from '@dreryk/react-components';

export const StyledMedicalInformationTable = styled(StyledFlex)`
   height: 100%;
`;
StyledMedicalInformationTable.displayName = 'StyledMedicalInformationTable';
